import { Component } from '@angular/core';
import { LayoutContainerComponent } from '../../components/layout-container/layout-container.component';
import { SectionHeadingComponent } from '../../components/section-heading/section-heading.component';
import { CtaBannerComponent } from '../../components/cta-banner/cta-banner.component';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [
    LayoutContainerComponent,
    SectionHeadingComponent,
    CtaBannerComponent
  ],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent { }
